import { render, staticRenderFns } from "./UserProfileTrainingCard.vue?vue&type=template&id=349bb6d1&scoped=true"
import script from "./UserProfileTrainingCard.vue?vue&type=script&lang=js"
export * from "./UserProfileTrainingCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileTrainingCard.vue?vue&type=style&index=0&id=349bb6d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349bb6d1",
  null
  
)

export default component.exports